import { TableBody } from "@mui/material";
import { FinancialSummaryRow } from "./FinancialSummaryRow";
import { BudgetRow } from "./types";

interface FinancialSummaryProps {
  rows: BudgetRow[];
  months: string[];
}

export const FinancialSummary = ({ rows, months }: FinancialSummaryProps) => {
  const calculateMonthlyTotals = () => {
    const totals: { [month: string]: { ebitda: number; depreciation: number } } = {};

    // Initialize totals for all months
    months.forEach(month => {
      totals[month] = { ebitda: 0, depreciation: 0 };
    });

    // Calculate totals
    rows.forEach(row => {
      if (!row.isSum && !row.isGroupTotal && row.number) {
        months.forEach(month => {
          const amount = row.amounts[month] || 0;

          // Depreciation accounts typically start with 78
          if (row.number.startsWith('78')) {
            totals[month].depreciation += amount;
          } else {
            totals[month].ebitda += amount;
          }
        });
      }
    });

    return totals;
  };

  const totals = calculateMonthlyTotals();

  // Prepare the final amounts objects
  const ebitda = Object.fromEntries(
    months.map(month => [month, totals[month].ebitda])
  );

  const depreciation = Object.fromEntries(
    months.map(month => [month, totals[month].depreciation])
  );

  const ebit = Object.fromEntries(
    months.map(month => [month, totals[month].ebitda - totals[month].depreciation])
  );

  return (
    <TableBody sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
      {/*<FinancialSummaryRow
        label="EBITDA"
        englishLabel="Rörelseresultat före avskrivningar"
        amounts={ebitda}
      />*/}
      <FinancialSummaryRow
        label="Avskrivningar"
        englishLabel="Depreciation"
        amounts={depreciation}
        isNegative={true}
      />
      {/*<FinancialSummaryRow
        label="EBIT"
        englishLabel="Rörelseresultat"
        amounts={ebit}
      />*/}
    </TableBody>
  );
};